import { Link } from 'react-router-dom';
import { Alert } from '@/components/ui/Alert';

/** Full-width denial panel shown in place of a page the admin can't open. */
export default function AccessDenied({ sectionName }: { sectionName: string }) {
  return (
    <div className="p-6" data-testid="access-denied">
      <Alert variant="error">
        You don't have access to {sectionName}.
      </Alert>
      <Link to="/dashboard" className="inline-block mt-4 text-sm text-primary underline">
        Back to Dashboard
      </Link>
    </div>
  );
}
